import { useEffect, useState } from 'react'

/**
 * Returns false on the server and during the first client render, then true.
 *
 * Use this to gate anything that reads browser-only state (localStorage, MSAL
 * accounts, window) and feeds it into markup. Reading that state directly
 * during render makes the first client render disagree with the server HTML,
 * which React reports as a hydration error.
 */
export default function useHasMounted() {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  return hasMounted
}
